import { CLASSES } from './classes';

export const DEFAULT_TEACHERS = [
  { email: 'vibha.mishra@mpsvns.in', name: 'Vibha Mishra' },
  { email: 'pooja.mam@mpsvns.in', name: 'Pooja Mam' },
  { email: 'santosh.verma@mpsvns.in', name: 'Santosh Verma' },
  { email: 'jai.prakash@mpsvns.in', name: 'Jai Prakash' },
  { email: 'satish.sir@mpsvns.in', name: 'Satish Sir' },
  { email: 'raj.kumar@mpsvns.in', name: 'Raj Kumar' },
  { email: 'ayush.kushnwaha@mpsvns.in', name: 'Ayush Kushwaha' },
  { email: 'visakha.chaurasiya@mpsvns.in', name: 'Visakha Chaurasiya' },
  { email: 'anchal.pandey@mpsvns.in', name: 'Anchal Pandey' },
];

export function teacherSeedPayload(teacher) {
  return {
    email: teacher.email.toLowerCase(),
    name: teacher.name,
    role: 'TEACHER',
    allClasses: true,
    assignedClasses: [...CLASSES],
  };
}
